module.exports = __webpack_public_path__ + "static/media/country4.5a425c9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/country4.png
// module id = 68
// module chunks = 0